import { Link } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { ErrorWithContact } from "@components/errors/ErrorWithContact/ErrorWithContact";
import { ErrorTemplate } from "@components/ErrorTemplate/ErrorTemplate";
import { useTenant } from "@contexts/Tenant/Tenant.context";
import { CustomTrans } from "@utils/translations/CustomTrans";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import type { DashboardFeedbackProps } from "./DashboardFeedback.types";

export const DashboardFeedback: FC<DashboardFeedbackProps> = ({
  error,
  energyType,
}) => {
  const { t } = useCustomTranslation("main");
  const { salesEmail = "" } = useTenant();

  if (error?.response?.data?.code === "NOT_FOUND") {
    return (
      <ErrorTemplate
        data-testid="DashboardFeedback-errorImage"
        imageType={energyType === "ELEC" ? "electricity" : "gas"}
        text={
          <CustomTrans
            components={{
              salesLink: <Link href={`mailto:${salesEmail}`} />,
            }}
            i18nKey="dashboard.noEnergy"
            ns="main"
            values={{ salesEmail }}
          />
        }
        title={t("dashboard.error", {
          energyType,
        })}
      />
    );
  }

  return <ErrorWithContact />;
};
